<template>
  <div class="first-address-book">
    <button @click="$emit('quit')" class="close mt-2 mr-2 bg-light">
      <b-icon-x class="" />
    </button>
    <div class="pt-3" :class="{ 'section-disabled': disableAddressBook }">
    <div class="address-book">
        <h4 class="text-black-50 ml-40px">Patientenregister</h4>
        <div class="input-group d-flex w-75 mt-2 ml-3">
          <input
            type="text"
            class="form-control border-right-0 border h-27-px"
            @input="filterClients($event.target.value)"
            aria-label="Search"
          />
          <span class="input-group-append h-27-px">
            <div class="input-group-text bg-transparent">
              <b-icon class="icon-input-search" scale="0.6" icon="search" />
            </div>
          </span>
        </div>
      </div>
      <div class="address-book scrollable-div d-flex mt-3" :style="{ 'height': `${resizableBoxSize}px` }">
        <div class="mt-5">
          <nav id="sidebar" class="navbar ">
            <ul class="flex-md-column navbar-nav">
              <li class="address-book-abc-side" v-for="i in 26">
                <a
                  class="nav-link pt-0 pb-0  pl-0"
                  @click="
                    filterClients(
                      String.fromCharCode(64 + i),
                      true,
                      'startsWith'
                    )
                  "
                  href="javascript:void(0)"
                  >{{ String.fromCharCode(64 + i) }}</a
                >
              </li>
            </ul>
          </nav>
        </div>
        <div class="client-list">
          <h5 class="color-red">Praxis-Konto</h5>
          <a
            @click="selectClient(connectedUser.identity.id, connectedUser.identity.fullname, true)"
            class="text-black-50 d-block clickable"
            href="javascript:void(0)"
          >
            {{ connectedUser.identity.fullname }}
          </a>
          <div
            v-if="
              clientList.hasOwnProperty('employees') ||
                clientList.hasOwnProperty('clients')
            "
          >
            <h5 class="color-orange mt-5">Mitarbeiter</h5>
            <a
              class="text-black-50 d-flex clickable"
              href="javascript:void(0)"
              v-for="employee in clientList.employees"
              :key="employee.id"
              @click="
                selectClient(
                  employee.id,
                  `${employee.firstname} ${employee.lastname}`,
                  false
                )
              "
            >
              {{ employee.lastname }}, {{ employee.firstname }}
              <span v-if="employee.isFutalisCustomer"
                ><i class="ml-1 icon-futalis-avatar"
              /></span>
            </a>
            <h5 class="color-green mt-5">Kunden</h5>
            <a
              class="text-black-50 d-flex clickable"
              href="javascript:void(0)"
              v-for="client in clientList.clients"
              :key="client.id"
              @click="
                selectClient(
                  client.id,
                  `${client.firstname} ${client.lastname}`,
                  false
                )
              "
            >
              {{ client.lastname }}, {{ client.firstname }}
              <span v-if="client.isFutalisCustomer"
                ><i class="ml-1 icon-futalis-avatar"
              /></span>
            </a>
          </div>
          <div v-else class="pt-5 pr-4 color-orange">
            Sie haben Artikel aus dem Vet Shop im Warenkorb. Sie können für Ihre
            eigenen Hunde Futterrationen mit bestellen. Für
            Patientenbestellungen schließen Sie bitte vorher die Bestellung ab.
          </div>
        </div>
      </div>
      <div class="center-middle mt-2">
        <label class="font-footer-small text-black-50">
          Kunde über futalis.de
        </label>
        <i class="ml-1 icon-futalis-avatar" />
      </div>

      <div class="w-100">
        <div class="d-flex center-middle mt-2">
          <button
            @click="$emit('addNewClient')"
            title="neuer Patientenhalter"
            id="new-client-trigger"
            :class="{ 'section-disabled': cartContent.hasVetShopItems }"
            class="button-first-address-book mx-2 futalis-button-green text-white  d-flex futalis-btn"
          >
            <i class="fas fa-plus mt-2 vertical-align-middle" />
            <i class="icon-patientenregister ml-2" />
          </button>
          <button
            @click="vetShop()"
            class="button-first-address-book mx-2 futalis-button-orange text-white text-center futalis-btn"
          >
            VET SHOP
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {deleteCookie} from "@/helpers/userHelper";

export default {
  name: 'FirstAddressBook',
  props: ['clients', 'connectedUser', 'selectClient', 'disableAddressBook'],
  data() {
    return {
      filter: {
        text: '',
        onlyLastname: false,
        searchStrategy: 'includes'
      },
      resizableBoxSize: window.innerWidth <= 768 ? window.innerHeight - 195 : 585,
    };
  },
  methods: {
    filterClients(text, onlyLastname = false, searchStrategy = 'includes') {
      const resetFilter =
        onlyLastname && text.length === 1 && text === this.filter.text;
      if (resetFilter) {
        this.filter = {
          ...this.filter,
          text: '',
          onlyLastname: false,
          searchStrategy: 'includes'
        };
        return true;
      }
      this.filter = { ...this.filter, text, onlyLastname, searchStrategy };
    },
    vetShop() {
      deleteCookie('client_id');
      window.open('/vet-shop');
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onResize);
    },
    onResize() {
      this.resizableBoxSize = window.innerWidth <= 768 ? window.innerHeight - 195 : 585;
    }
  },
  computed: {
    ...mapState({
      checkout: state => state.checkOutModule,
      cartContent: state => state.checkOutModule.cart,
    }),
    clientList() {
      const clientTypes = Object.keys(this.clients);
      if (clientTypes.length === 0 || this.checkout.cart.hasVetShopItems) {
        return {};
      }
      return clientTypes.reduce((accumulator, clientType) => {
        const sortedClients = Object.values(this.clients[clientType])
          .sort((a, b) =>
              a.lastname.toLowerCase() > b.lastname.toLowerCase() ? 1 : b.lastname.toLowerCase() > a.lastname.toLowerCase() ? -1 : 0
          )
          .filter(
            client =>
              (this.filter.text !== '' &&
                client.firstname
                  .toLowerCase()
                  [this.filter.searchStrategy](
                    this.filter.text.toLowerCase()
                  ) &&
                !!!this.filter.onlyLastname) ||
              client.lastname
                .toLowerCase()
                [this.filter.searchStrategy](this.filter.text.toLowerCase())
          );

        accumulator = Object.assign(accumulator, {
          ...accumulator,
          [clientType]: sortedClients
        });
        return accumulator;
      }, {});
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onResize);
    });
  },
  watch: {
    clients() {
      this.filter = {
        ...this.filter,
        text: '',
        onlyLastname: false,
        searchStrategy: 'includes'
      };
    }
  }
};
</script>

<style scoped>
.scrollable-div {
  height: 585px;
  width: 100%;
  overflow-y: scroll !important;
}
.first-address-book {
  width: 318px;
  height: 768px;
}
@media (max-width: 768px) {
  .first-address-book {
    width: 100% !important;
    height: calc(100vh - 5px) !important;
  }
  .scrollable-div {
    /*height: calc(100vh - 195px) !important;*/
    /*width: 100% !important;*/
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .scrollable-div::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
}

::-webkit-scrollbar {
  width: 13px;
  border: 5px solid white;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  background-clip: padding-box;
  border: 0.05em solid #eeeeee;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-button:single-button {
  background-color: #f1f1f1;
  display: flex;
  border-style: solid;
  height: 10px;
  width: 7px;
}

::-webkit-scrollbar-button:single-button:vertical:decrement {
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent #555555 transparent;
}

::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
  border-color: transparent transparent #777777 transparent;
}

::-webkit-scrollbar-button:single-button:vertical:increment {
  border-width: 8px 8px 0 8px;
  border-color: #555555 transparent transparent transparent;
}

::-webkit-scrollbar-button:vertical:single-button:increment:hover {
  border-color: #777777 transparent transparent transparent;
}

.color-red {
  color: #d04244;
}
.color-orange {
  color: #f0bc36;
}
.color-green {
  color: #7e9125;
}

.address-book {
  font-size: 1.2rem;
}

.button-first-address-book {
  display: inline-block;
  font-weight: 400;
  vertical-align: middle;
  border: 1px solid transparent;
  padding: 0.4rem 0.6rem;
  font-size: 0.9rem;
  line-height: 1.5;
}
.form-control:focus {
  outline: 0 !important;
  border-color: initial;
  box-shadow: none;
}
</style>
